/** Registered by account.jsx only when the signed-in user is the Owner. */
export const BILLING_PATH = '/global-settings/account/billing';
